import { openModal } from "./utils"
import { POSTAL_CODE_PREFIXES, POSTAL_CODE_REGEX } from "./constants";
import { filter } from "lodash";


window.addEventListener('load', () => {
       const modalInicio = document.getElementById('modalInicio');
       if (modalInicio && !modalInicio.classList.contains('hidden')) {
        document.getElementById('mainNav')?.classList.add('hidden');
        document.getElementById('mainNavMobile')?.classList.add('hidden');
        document.getElementById('mobile-nav-top')?.classList.add('hidden');
       
    }
    initPostalCodes();
    
   

    const putPostalCodeForm = document.getElementById('put-postal-code-form')
    const putPostalCodeFormModal = document.getElementById('put-postal-code-form-modal')
    if (putPostalCodeForm) {
        putPostalCodeForm.addEventListener('submit', (e) => {
            e.preventDefault()
            document.getElementById('put-postal-code-error-span').innerText = ''
            handleValidatePostalCode()
        })
    }
    if (putPostalCodeFormModal) {
        putPostalCodeFormModal.addEventListener('submit', (e) => {
            e.preventDefault()
            document.getElementById('put-postal-code-error-span').innerText = ''
            handleValidatePostalCode()
        })
    }

    Array.from(document.getElementsByClassName('postal-code-edit-cta')).forEach((cta) => {
        cta.addEventListener('click', () => {
            handlePopulatePostalCodeModal()
        })
    })

    const defaultAddress = document.getElementById('default_address')
    if (defaultAddress) {
        // El span puede traer el CP en texto plano o un objeto serializado con la dirección
        const contenido = defaultAddress.innerText.trim()
        let cp = contenido
        try {
            const parsed = JSON.parse(contenido)
            cp = parsed !== null && typeof parsed === 'object' ? parsed.cp : parsed
        } catch (e) {
            cp = contenido
        }
        displayPostalCode(cp)
    }

})

const displayPostalCode = (postalCode) => {

    if (postalCode === null || postalCode === undefined || postalCode === '') return

    const postalCodePrefix = postalCode.toString().substring(0, 2)
    const city = POSTAL_CODE_PREFIXES.find((cityData) => postalCodePrefix == cityData.postal_code_prefix)

    const textoCp = `${city ? city.name : ''} ${postalCode}`;
    const cpDesktop = document.getElementById('mt_cp');
    const cpMovil = document.getElementById('mt_cp_movil');
    if (cpDesktop) cpDesktop.innerText = textoCp;
    if (cpMovil) cpMovil.innerText = textoCp;
}

const handleValidatePostalCode = () => {
    const homeInput = document.querySelector('input[name="postal_code_home"]');
    const modalInput = document.querySelector('input[name="postal_code_modal"]');
    
    const postalCode = homeInput?.value
        ? homeInput.value
        : modalInput?.value ?? '';
        

    if (!POSTAL_CODE_REGEX.test(postalCode)) {
        document.getElementById('put-postal-code-error-span').innerText = 'El código postal introducido no es válido'
        return
    }

    window.localStorage.setItem('mt_cp', postalCode)


    fetch("/save-localstorage", {
        method: "POST",
        headers: {
           'Content-Type': 'application/json',
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        body: JSON.stringify({ mt_cp: postalCode })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Error en la petición');
        }
        return response.json();
    })
    .then(data => {
        console.log("Respuesta del servidor:", data);
    })
    .catch(error => {
        console.error("Ocurrió un error:", error);
    });
    setTimeout(() => {
        window.location.reload();
      }, 1000);
}


window.cambiarPorDireccionUser = (postalCode, idDireccion = null) => {

    if(postalCode == 'cp'){
        postalCode = $('#postal_code_modal_direcciones').val();
    }

    window.localStorage.setItem('mt_cp', postalCode);
    fetch("/save-localstorage-direccion", {
        method: "POST",
        headers: {
           'Content-Type': 'application/json',
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        body: JSON.stringify({ mt_cp: postalCode, id: idDireccion })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Error en la petición');
        }else{
            window.location.reload();
        }
        return response.json();
    })

}




const initPostalCodes = () => {
    
    if (!document.getElementById('mt_cp')) {
        return
    }

    let postalCode = window.localStorage.getItem('mt_cp')
    if (!POSTAL_CODE_REGEX.test(postalCode)) {
        postalCode = null
    }

    if (!postalCode) {

            fetch("/save-localstorage", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                body: JSON.stringify({ mt_cp: null })
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Error en la petición');
                }
                return response;
            })
            .catch(error => {
                console.error("Ocurrió un error:", error);
            });
        return;
    }

    displayPostalCode(postalCode);
}

const handlePopulatePostalCodeModal = () => {
    let postalCode = window.localStorage.getItem('mt_cp')
    document.querySelector('input[name="postal_code_modal"]').value = postalCode
    document.getElementById('put-postal-code-error-span').innerText = ''
    window.openSheet('put-postal-code-modal')
}


window.editReview = (id) => {
    const text = document.getElementById('text-review-' + id);
    const textarea = document.getElementById('textarea-review-' + id);
    const saveBtn = document.getElementById('save-review-' + id);

    if (textarea.classList.contains('hidden')) {
        textarea.classList.remove('hidden');
        saveBtn.classList.remove('hidden');
        text.classList.add('hidden');

        textarea.focus();
    } 
    else {
        textarea.classList.add('hidden');
        saveBtn.classList.add('hidden');
        text.classList.remove('hidden');

        textarea.value = text.innerText.trim();
    }
}